import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from "react";
export function wrapLocalBrick(brick, eventsMapping) {
  // istanbul ignore next
  if (process.env.NODE_ENV === "development") {
    if (typeof brick === "string" && !customElements.get(brick)) {
      throw new Error(`Brick ${brick} is not defined while using \`wrapLocalBrick\`.`);
    }
  }
  return /*#__PURE__*/forwardRef(function BrickReactWrapper(_ref, ref) {
    let {
      children,
      ...props
    } = _ref;
    const WebComponent = typeof brick === "string" ? brick : brick.__tagName;
    const properties = getMappedProperties(props, eventsMapping);
    return /*#__PURE__*/React.createElement(WebComponent, _extends({}, properties, {
      ref: ref
    }), children);
  });
}
export function wrapBrick(BrickName, eventsMapping) {
  return /*#__PURE__*/forwardRef(function BrickReactWrapper(_ref2, ref) {
    let {
      children,
      ...props
    } = _ref2;
    const properties = getMappedProperties(props, eventsMapping);
    return /*#__PURE__*/React.createElement(BrickName, _extends({}, properties, {
      ref: ref
    }), children);
  });
}
function getMappedProperties(props, eventsMapping) {
  let properties;
  if (eventsMapping) {
    properties = {};
    for (const [propName, propValue] of Object.entries(props)) {
      if (Object.prototype.hasOwnProperty.call(eventsMapping, propName)) {
        properties[`on${eventsMapping[propName]}`] = propValue;
      } else {
        properties[propName] = propValue;
      }
    }
  } else {
    properties = props;
  }
  return properties;
}
//# sourceMappingURL=wrapBrick.js.map